import { create } from 'zustand';
import { formatCurrency, DEFAULT_CURRENCY } from '@/lib/utils/currency';

/**
 * Wallet Store State Interface
 */
interface WalletState {
  balance: string;
  currency: string;
  refreshBalance: () => Promise<void>;
}

/**
 * Zustand Wallet Store
 *
 * Provides global wallet balance state that can be:
 * - Read by the navbar
 * - Refreshed on page load
 */
export const useWalletStore = create<WalletState>()((set) => ({
  balance: "€0.00",
  currency: "EUR",

  refreshBalance: async () => {
    try {
      const response = await fetch("/api/wallet/balance");
      if (response.ok) {
        const data = await response.json();
        const balanceNum = parseFloat(data.wallet?.balance || "0");
        const currency = data.wallet?.currency || DEFAULT_CURRENCY;
        set({
          balance: formatCurrency(balanceNum, currency),
          currency,
        });
      }
    } catch (error) {
      console.error("Failed to fetch wallet balance:", error);
    }
  },
}));
